import { css } from 'styled-components';
import { rem } from './units';
export function getFontStyle(fontStyle) {
    return css `
    ${({ theme }) => `
      font-family: ${theme.Typography.FontFamily};
      font-size: ${rem(theme.Typography.Size[fontStyle].FontSize)};
      font-weight: ${theme.Typography.Size[fontStyle].FontWeight};
      line-height: ${rem(theme.Typography.Size[fontStyle].LineHeight)};
    `}
  `;
}
//# sourceMappingURL=typography.js.map